interface TeamStats {
  played: number;
  wins: number;
  draws: number;
  losses: number;
  halfTimeWins: number;
  halfTimeDraws: number;
  halfTimeLosses: number;
  cleanSheets: number;
  btts: number;
  htBtts: number;
}

export const calculateHomeStats = (homeTeamStats: any): TeamStats => ({
  played: homeTeamStats.homeMatches,
  wins: homeTeamStats.fullTimeStats.homeWins,
  draws: homeTeamStats.fullTimeStats.homeDraws,
  losses: homeTeamStats.fullTimeStats.homeLosses,
  halfTimeWins: homeTeamStats.halfTimeStats.homeWins,
  halfTimeDraws: homeTeamStats.halfTimeStats.homeDraws,
  halfTimeLosses: homeTeamStats.halfTimeStats.homeLosses,
  cleanSheets: homeTeamStats.fullTimeStats.homeCleanSheets,
  btts: homeTeamStats.fullTimeStats.homeBTTS,
  htBtts: homeTeamStats.halfTimeStats.homeBTTS,
});

export const calculateAwayStats = (awayTeamStats: any): TeamStats => ({
  played: awayTeamStats.awayMatches,
  wins: awayTeamStats.fullTimeStats.awayWins,
  draws: awayTeamStats.fullTimeStats.awayDraws,
  losses: awayTeamStats.fullTimeStats.awayLosses,
  halfTimeWins: awayTeamStats.halfTimeStats.awayWins,
  halfTimeDraws: awayTeamStats.halfTimeStats.awayDraws,
  halfTimeLosses: awayTeamStats.halfTimeStats.awayLosses,
  cleanSheets: awayTeamStats.fullTimeStats.awayCleanSheets,
  btts: awayTeamStats.fullTimeStats.awayBTTS,
  htBtts: awayTeamStats.halfTimeStats.awayBTTS,
});

export const calculatePoints = (stats: TeamStats): number => {
  return stats.wins * 3 + stats.draws;
};